export default __webpack_public_path__ + "static/media/489.ee2ed614.png";